module.exports = __webpack_public_path__ + "static/media/blue_back.8a890151.png";